import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../AppContext';
import { useSearchParams, useMatch  } from 'react-router-dom';
// import QuickSightDashboard from '../../components/QuickSightDashboard/QuicksightDashboard';
import QuickSightDashboard2 from '../../components/QuickSightDashboard/QuicksightDashboard2';
// import NBAHeader from '../../components/NBAHeader/NBAHeader';
import NBAEditorial from '../../components/NBAEditorial/NBAEditorial';
// import NBATabs from '../../components/NBAHeader/NBATabs';


const HomeView = (props) => { 

    const { apiKey, availableDashboards, setMenuTitle, embedContext, realTime, hideHeader } = useContext(AppContext);

    // const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [position, setPosition] = useState(searchParams.get("position") || "All Positions");
    const [year, setYear] = useState(searchParams.get("year") || "2026");
    // const [dashboardId, setDashboardId] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.key)
    // const [dashboardTitle, setDashboardTitle] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.text)
    // const [dashboardType, setDashboardType] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.type)
    const match = useMatch("/overview");
    const [isOverview, setIsOverview] = useState(false);

    useEffect(() => {
        setIsOverview(!!match);
    }, [match]);


    useEffect(() => {
        const nextPosition = searchParams.get("position") || "All Positions";
        const nextYear = searchParams.get("year") || "2026";

        setPosition((prev) =>
        prev === nextPosition ? prev : nextPosition
        );

        setYear((prev) =>
        prev === nextYear ? prev : nextYear
        );
    }, [searchParams]);

    const mobileRatio = 3.85;
    const desktopRatio = .75;
        
    const [mobile, setMobile] = useState(window.innerWidth < 768);
    // const [selectedDashboard, setSelectedDashboard] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0])
    const [height, setHeight] = useState(window.innerWidth < 768 ? window.innerWidth * mobileRatio : window.innerWidth * desktopRatio)

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            // setViewportWidth(width);

            // update something when width changes
            if (width < 768) {
                setMobile(true);
                setHeight(window.innerWidth * mobileRatio);
            } else {
                setMobile(false);
                setHeight(window.innerWidth * desktopRatio);
            }
        };

        window.addEventListener("resize", handleResize);

        // run once on mount
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    
    useEffect(() => {

    }, [mobile])



    // useEffect(() => {
    //     if(!!params?.dashboardId && availableDashboards?.length >0) {
    //         // console.log('availableDashboards: ', availableDashboards);
    //         const dashboard = availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0];
    //         setSelectedDashboard(dashboard)
    //         // setDashboardId(dashboard?.key);
    //         // setDashboardType(dashboard?.type);
    //         // !!dashboard?.text && setDashboardTitle(dashboard?.text);
    //         !!dashboard?.text && setMenuTitle(dashboard?.text);  
    //     }

    // }, [params, availableDashboards])
    
    //eslint-disable-next-line
    let whatever = import.meta.env;



    const defaultItems = [
    {
        imageUrl:
        "/draftcombinestations.jpg",
        header: "2026 AWS NBA Draft Combine Data Hub",
        linkUrl: "https://www.nba.com/news/2026-aws-nba-draft-combine-data-hub-everything-you-need-to-know",
        externalLink: true,
        copy:
        "The new 2026 AWS NBA Draft Combine data hub turns measurements into insights, bringing context to every testing metric.",
    },
    {
        imageUrl:
        "https://cdn.nba.com/manage/2026/04/VL.jpg",
        header: "NBA Draft Combine: Highest Max Vertical Leaps",
        linkUrl: "https://www.nba.com/news/nba-draft-combine-highest-max-vertical-leaps",
        externalLink: true,
        copy:
        "Tracking the Draft Combine history of players who recorded the highest vertical leaps.",
    },
    {
        imageUrl:
        "https://cdn.nba.com/manage/2026/04/Picture1.png",
        header: "NBA Draft Combine: Largest Wingspans",
        linkUrl: "https://www.nba.com/news/nba-draft-combine-largest-wingspans",
        externalLink: true,
        copy:
        "See which players recorded the 10 largest wingspans in the history of the NBA Draft Combine.",
    },
    {
        imageUrl:
        "https://cdn.nba.com/manage/2026/01/2026-NBA-Draft-logo-white.png?w=384&h=224",
        header: "2026 NBA Draft: Complete Coverage",
        linkUrl: "https://www.nba.com/draft/2026",
        externalLink: true,
        copy:
        "Get updated prospect info, team previews, mock drafts and all the latest Draft news at the official site of the 2026 NBA Draft.",
    },
    ];


    return <>
        {/* <NBATabs items={defaultItems.slice(1)}/>
        <NBAHeader /> */}
        {isOverview ? <></> : <NBAEditorial items={defaultItems}/>}
        <QuickSightDashboard2 
            key={!mobile ? availableDashboards[0]?.key : availableDashboards[1]?.key}
            dashboardId={!mobile ? availableDashboards[0]?.key : availableDashboards[1]?.key} 
            dashboardTitle={'AWS NBA Draft Combine 2026'}
            dashboardType={'dashboard'}
            dashboardSubtype={""}
            apiKey={apiKey}
            realTime={realTime}
            embedContext={embedContext}
            height={height}
            dropdowns={['year','position']}
            initialParams={[{"Name":"PositionSelect","Values":[position]}, {"Name":"DraftYear2","Values":[year === "All Records" ? "All Time" : year]}]}
            singleSheet={import.meta?.env?.VITE_HIDETABS ==="true" ? true : false}
        />
    </>
};

export default HomeView;